import {
  RavenCopyText,
  RavenInputField,
  RavenTable,
  RavenTableRow,
  RavenToolTip,
} from "@ravenpay/raven-bank-ui";
import { debounce } from "lodash";
import React, { useContext, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import RootState from "../../../redux/types";
import { getAllInsightTerminals } from "../../../redux/insight";
import {
  colorToRgba,
  generalSearchFunctionality,
} from "../../../utils/helpers";
import ActionContext from "../../../context/ActionContext";
import { CSVLink } from "react-csv";
import {
  capitalizeFirstLetter,
  formatNumWithCommaNairaSymbol,
} from "../../../helper";
import ExportFragment from "../../../fragments/ExportFragment";
import PaginationFragment from "../../../fragments/PaginationFragment";
import PerPageComponent from "../../../fragments/PerPageComponent";
import TwoDetailView from "../../../fragments/TwoDetailView";
import BadgeComponent from "../../../fragments/badge/BadgeComponent";
import { useNavigate } from "react-router-dom";
import { encrypt2 } from "../../../utils/encrypt";
import { RouteLinks } from "../../../routes/RouteLinks";
import MobileTableCard from "../../../fragments/MobileTableWrap";
import "../../../styles/dashboard/terminals/ListViewTerminalDetailsIndex.css";
import AllMerchantTerminals from "./AllMerchantTerminals";
import NoContentPage from "../../../fragments/NoContentPage";
import GridListViewSwitch from "../../../fragments/grid-list-switch/GridViewSwitch";

interface MyComponentProps {
  list?: any;
}

const ListViewPhysicalTerminals = ({ list }: MyComponentProps) => {
  const [search, setSearch] = useState("");
  const [all_terminals, setAllTerminals] = useState<any>({});
  const dispatch = useDispatch();
  const actionCtx = useContext(ActionContext);
  const [currentPage, setCurrentPage] = useState(1);
  const { loading, insight_terminals } = useSelector(
    (state: RootState) => state.insights
  );

  const CsvHeader = [
    { label: "S/N", key: "num" },
    { label: "TERMINAL LABEL", key: "tid_label" },
    { label: "TERMINAL ID", key: "tid" },
    { label: "SERIAL NO", key: "serial" },
    { label: "BANK TRANSFER AMOUNT", key: "transfer_volume" },
    { label: "CARD TRANSFER AMOUNT", key: "card_volume" },
    { label: "TOTAL AMOUNT", key: "cal" },
    { label: "STATUS", key: "status" },
  ];
  const tableList = [
    "TERMINAL DETAIL",
    "SERIAL NO.",
    "TRANSFERS",
    "CARD  TRANSACTION",
    "TOTAL AMOUNT",
    "STATUS",
  ];

  interface PaginationResult<T> {
    currentPage: number;
    perPageArrays: T[][];
    totalPages: number;
    nextPage: number | null;
    prevPage: number | null;
    arrayToShow: any;
    startIndex: number;
    endIndex: number;
  }
  // useEffect(() => {
  //   if (Object?.keys(actionCtx?.configDetails)?.length > 0) {
  //     getAllInsightsTerminalsFunc();
  //   }

  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [actionCtx?.configDetails]);

  useEffect(() => {
    if (insight_terminals?.data?.length > 0) {
      paginateArray(
        insight_terminals?.data,
        actionCtx?.perPageGlobalVal?.value,
        currentPage
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    insight_terminals,
    currentPage,
    actionCtx.perPageGlobalVal,
    actionCtx?.configDetails,
  ]);

  const formatExportData = (data: any) => {
    const list = data?.map((chi: any, idx: any) => {
      return {
        num: idx < 10 ? `0${idx + 1}` : idx + 1,
        tid_label: capitalizeFirstLetter(chi?.tid_label),
        tid: chi?.tid,
        serial: chi?.tid_label,
        transfer_volume: formatNumWithCommaNairaSymbol(
          String(chi?.transfer_volume)
        ),
        card_volume: formatNumWithCommaNairaSymbol(String(chi?.card_volume)),
        cal: formatNumWithCommaNairaSymbol(
          String(Number(chi?.transfer_volume) + Number(chi?.card_volume))
        ),
        status: "success",
      };
    });
    return list;
  };

  function paginateArray<T>(
    array: T[],
    pageSize: number,
    currentPage: number
  ): PaginationResult<T> {
    const perPageArrays: T[][] = [];
    const totalPages = Math.ceil(array.length / pageSize);
    const startIndex = (currentPage - 1) * pageSize;
    const endIndex = Math.min(startIndex + pageSize, array.length);

    for (let i = 0; i < totalPages; i++) {
      const startIndex = i * pageSize;
      const endIndex = Math.min(startIndex + pageSize, array.length);
      perPageArrays.push(array.slice(startIndex, endIndex));
    }

    const obj = {
      currentPage,
      perPageArrays,
      totalPages,
      startIndex: startIndex + 1,
      endIndex,
      arrayToShow: perPageArrays[currentPage - 1],
      nextPage: currentPage < totalPages ? currentPage + 1 : null,
      prevPage: currentPage > 1 ? currentPage - 1 : null,
    };
    setAllTerminals(obj);
    return obj;
  }
  const navigate = useNavigate();
  const getAllInsightsTerminalsFunc = async () => {
    dispatch(getAllInsightTerminals({} as any) as any);
  };
  const handleSearch = debounce(async (param: any) => {
    const newList = generalSearchFunctionality(
      param,
      ["serial", "tid", "tid_label"],
      insight_terminals?.data
    );
    paginateArray(newList, actionCtx?.perPageGlobalVal?.value, currentPage);
  }, 50);

  return (
    <>
      <div
        // onClick={() => {
        //   console.log(insight_terminals);
        // }}
        className="all-terminal-dashboard-index-wrap"
      >
        {list?.length < 1 ? (
          <>
            <NoContentPage
              styles={{
                height: "calc(100vh - 40rem)",
                border: "unset",
                boxShadow: "unset",
                padding: "unset",
              }}
              loading={loading}
            />
          </>
        ) : (
          <>
            {" "}
            <div
              // onClick={() => {
              //   console.log(all_terminals?.arrayToShow);
              // }}
              className="table-content-box"
            >
              {/* big table start  */}

              <div className="big-table">
                <RavenTable headerList={tableList}>
                  {list?.map((chi: any, idx: any) => {
                    return (
                      <RavenTableRow
                        loading={loading}
                        key={idx}
                        one={
                          <TwoDetailView
                            title={capitalizeFirstLetter(chi?.tid_label)}
                            text_one={chi?.tid}
                          />
                        }
                        two={
                          <RavenCopyText
                            trimNum={35}
                            stopPropagation
                            text={chi?.serial || " "}
                            copyIconColor="var(--primary-base-color)"
                            copyIconBgColor={colorToRgba(
                              "var(--primary-base-color)",
                              0.1
                            )}
                            copiedBgColor=" var(--primary-base-color)"
                          />
                        }
                        three={
                          <TwoDetailView
                            title={formatNumWithCommaNairaSymbol(
                              String(chi?.transfer_volume)
                            )}
                            // title={chi?.card_amount}
                            // text_two={chi?.stan}
                          />
                        }
                        // three={chi?.t_id || "---"}
                        four={
                          <TwoDetailView
                            // text_one={chi?.bank_count}
                            title={formatNumWithCommaNairaSymbol(
                              String(chi?.card_volume)
                            )}
                            // text_two={chi?.stan}
                          />
                        }
                        five={
                          <TwoDetailView
                            // text_one={chi?.bank_count}
                            title={formatNumWithCommaNairaSymbol(
                              String(
                                Number(chi?.transfer_volume) +
                                  Number(chi?.card_volume)
                              )
                            )}
                            // text_two={chi?.stan}
                          />
                        }
                        six={
                          <BadgeComponent
                            className={
                              Number(chi?.status) === 1 ? "success" : `failed`
                            }
                            text={
                              Number(chi?.status) === 1 ? `Active` : `Inactive`
                            }
                          />
                        }
                        onRowClick={async () => {
                          //   console.log(chi);

                          const encryptedSerial = await encrypt2(
                            chi?.serial ?? ""
                          );
                          localStorage?.setItem("takwoski", encryptedSerial);
                          navigate(RouteLinks?.Terminal_details);
                        }}
                        // six={chi?.date}
                      />
                    );
                  })}
                </RavenTable>
              </div>
              {/* big table end */}

              {/* mobile wrap table start */}
              <div className="mobile-table-box">
                {list?.map((chi: any, idx: any) => {
                  return (
                    <MobileTableCard
                      amountColor={``}
                      text={`TID: ${chi?.tid}` || "---"}
                      textTwo={`Serial: ${chi?.serial}`}
                      title={capitalizeFirstLetter(chi?.tid_label) || "---"}
                      amount={
                        formatNumWithCommaNairaSymbol(
                          String(
                            Number(chi?.transfer_volume) +
                              Number(chi?.card_volume)
                          )
                        ) || "---"
                      }
                      key={idx}
                      onRowClick={async () => {
                        const encryptedSerial = await encrypt2(
                          chi?.serial ?? ""
                        );
                        localStorage?.setItem("takwoski", encryptedSerial);
                        navigate(RouteLinks?.Terminal_details);
                      }}
                      avatar={chi?.tid_label}
                      showImg
                      //   img={}
                      //   smallText={ref}
                      //   type={chi?.direction || " "}
                    />
                  );
                })}
              </div>
              {/* mobile wrrap table end */}
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default ListViewPhysicalTerminals;
